// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * Default Resource Filter Data
 */

export const exactNames = [
    // Conduit IAM Roles
    'IibsAdminAccess-DO-NOT-DELETE',
    'ConduitAccessClientRole-DO-NOT-DELETE',
    'AwsConfigRole-DO-NOT-DELETE',
    'RocketFuelDefaultRole',
    'InfoSecHostMonitoringInstanceProfileRole-DO-NOT-DELETE',
    'AWSBackupRole_DO_NOT_DELETE',
    'ConduitAccountSetupRole',
    'Conduit-AutoRemediation-DO-NOT-DELETE',
    'ConduitAuditRole-DO-NOT-DELETE',
    'IncidenceResponseClientRole-DO-NOT-DELETE',
    'VulnerabilityManagementClientRole-DO-NOT-DELETE',
    'EMR_DefaultRole',
    'EMR_EC2_DefaultRole',
    'DataPipelineDefaultResourceRole',
    'DataPipelineDefaultRole',
    
    // Conduit SNS Topics
    'DO-NOT-UNSUBSCRIBE-AwsConfig-ConduitAsap',
    'DO-NOT-UNSUBSCRIBE-CloudWatch-ConduitAsap',
    'DO-NOT-UNSUBSCRIBE-GuardDuty-ConduitAsap',
    'DO-NOT-UNSUBSCRIBE-User-Defined-Detections',
    
    // Conduit Rules
    'CONDUIT-MANAGED-RULE-DO-NOT-MODIFY-OR-DELETE',
    'GUARDDUTY-RULE-DO-NOT-MODIFY-OR-DELETE',
    
    // Service-Linked Roles
    'AWSServiceRoleForAccessAnalyzer',
    'AWSServiceRoleForAmazonGuardDuty',
    'AWSServiceRoleForAmazonGuardDutyMalwareProtection',
    'AWSServiceRoleForAmazonSSM',
    'AWSServiceRoleForConfig',
    'AWSServiceRoleForOrganizations',
    'AWSServiceRoleForResourceExplorer',
    'AWSServiceRoleForRoute53Resolver',
    'AWSServiceRoleForSupport',
    'AWSServiceRoleForTrustedAdvisor',
    
    // CDKToolkit Resources
    'CdkBootstrapVersion',
    'CloudFormationExecutionRole',
    'ContainerAssetsRepository',
    'DeploymentActionRole',
    'FilePublishingRole',
    'FilePublishingRoleDefaultPolicy',
    'ImagePublishingRole',
    'ImagePublishingRoleDefaultPolicy',
    'LookupRole',
    'StagingBucket',
    'StagingBucketPolicy',
    
    // Bootstrap Resources
    'CDKMetadata',
    'ClientConfiguration',
    'ProviderConfiguration',
    'ServiceEnvironment',
    'UrlPuller',

    // AWS EC2 Network Access Scope
    'Do-Not-Delete-CloudSec-IngressTraffic',
    'Do-Not-Delete-CloudSec-EgressTraffic'
];

export const prefixes = [
    // Conduit S3 Buckets
    'aws-config-bucket-',
    'access-log-do-not-delete-',
    
    // Pipeline S3 Buckets
    'deploymentbucket-',
    'deploymentloggingbucke-',
    'pipelinesbatsdeploymen-',
    'pipelinespdgdeployment-',
    
    // Pipeline IAM Roles
    'PdgPipelinesReadRole-',
    'PipelinesBATSRole-',
    'PdgPipelinesRole-',
    'Pipeline-ResourcesFilteri-',
    'PipelineApolloPDGDeplo-',
    'PipelinesBARSRole-',
    
    // Bootstrap Stacks
    'SuperStarBootstrap-',
    'BONESBootstrap-',
    'SuperStar-',
    
    // Bootstrap Resources
    'CfnRegistrarLambdaFunc',
    'CfnRegistrarLambdaFuncRole',
    'RPDKLoggingRole',
    'SuperStarRPDKLogGroup',
    'UrlPullerLambda',
    'UrlPullerLambdaRole',
    'BARS',
    'BARSAccessLoggingBucket',
    'BARSImageRepo',
    'BARSPipelinesBARSRole',
    'BARSPolicy',
    'ChangeSetApproverRole',
    'CodeDeployPipelinesCodeDeploy',
    'HydraHydraTest',
    'PipelinesCloudFormation',
    'PipelinesCloudWatch'
];

export const keywords = [
    'DO-NOT-DELETE',
    'DO-NOT-UNSUBSCRIBE',
    'DO-NOT-MODIFY',
    'PdgPipelines'
];

export const exactNamesSet = new Set(exactNames.map(name => name.toLowerCase()));
export const prefixesSet = prefixes.map(prefix => prefix.toLowerCase());
export const keywordsSet = keywords.map(keyword => keyword.toLowerCase());